/*eslint-disable*/ export const messages = JSON.parse("{\"modal.aria.back\":[\"Tilbage\"],\"modal.aria.close\":[\"Luk\"]}");
//# sourceMappingURL=messages.mjs.map